export const serverState = (() => window.serverState)();
